var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-player-v2"},[_c('div',{staticClass:"initializing-overlay text-center"},[_c('h1',{staticClass:"header-text"},[_vm._v("Downloading assets. Please wait...")]),_c('h6',{staticClass:"content-text"},[_vm._v("The speed of the download depends on your internet connection.")]),_c('Loader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }